var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9627 2.5C20.9627 1.67157 21.6343 1 22.4627 1H28.6194C29.4478 1 30.1194 1.67157 30.1194 2.5V6.75373C30.1194 7.58216 29.4478 8.25373 28.6194 8.25373H23.9627V10.0672H25.8257C31.7209 10.0672 36.5 14.8462 36.5 20.7415V31.3806C36.5 32.209 35.8284 32.8806 35 32.8806H26.7612V39.1045H23.7612V32.8806H22.0597V39.1045H19.0597V32.8806H5C4.17157 32.8806 3.5 32.209 3.5 31.3806V18.7313C3.5 13.9462 7.37909 10.0672 12.1642 10.0672H20.9627V2.5ZM20.9627 13.0672H17.989C18.2902 13.4478 18.561 13.8532 18.7981 14.2763C19.4706 15.4768 19.597 16.7944 19.597 17.8823V29.8806H33.5V20.7415C33.5 16.5031 30.0641 13.0672 25.8257 13.0672H23.9627V19.6269H20.9627V13.0672ZM16.597 29.8806V17.8823C16.597 16.9812 16.4804 16.2774 16.1808 15.7426C15.2391 14.0616 13.7128 13.0672 12.1642 13.0672C9.03594 13.0672 6.5 15.6031 6.5 18.7313V29.8806H16.597ZM23.9627 5.25373H27.1194V4H23.9627V5.25373ZM13.7313 21.6866H8.47015V18.6866H13.7313V21.6866Z",
    fill: "#A28957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.12fb7cd37e7e4f2c5bcbd6583c7b3400.svg";
export { ForwardRef as ReactComponent };